import classNames from 'classnames'

import ArrowDown from 'ui-component-library/icons/arrow-down.svg'
import HeadlineThree from 'ui-component-library/components/00-Primitives/Headlines/HeadlineThree'
import style from './style.scss'

export type AllowedVariants =
  | 'black'
  | 'black-condensed'
  | 'gray'
  | 'gray-condensed'
  | 'white'
  | 'white-condensed'

export type BaseProps = {
  className?: string
  details: React.ReactNode
  summary: string
}

type Props = BaseProps & {
  active?: boolean
  index: number
  showBottomBorders: boolean
  toggleActive: (arg0: number) => void
  variant: AllowedVariants
}

AccordionItem.defaultProps = {
  active: false,
  className: '',
}

function AccordionItem(props: Props) {
  const {
    active,
    className,
    details,
    index,
    showBottomBorders,
    summary,
    toggleActive,
    variant,
  } = props

  const variantStyles = variant.split('-').map((v) => style[v])

  return (
    <li
      className={classNames(
        variantStyles,
        {
          [style.borders]: showBottomBorders,
          [style.active]: active,
        },
        className,
      )}
    >
      <button
        aria-expanded={active}
        className={style.summaryBlock}
        data-testid='accordion-item'
        onClick={() => toggleActive(index)}
      >
        <HeadlineThree className={style.summaryText}>{summary}</HeadlineThree>
        <ArrowDown className={style.arrowIcon} />
      </button>
      <div className={style.details}>{details}</div>
    </li>
  )
}

export default AccordionItem
